module.exports = __webpack_public_path__ + "media/a10.f69128f6.mp3";